import React from "react";

function SvgIcMapPoi081(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M18.561 20.284c.87.436 1.486 1.086 1.665 1.833A5.694 5.694 0 0116 24c-1.675 0-3.18-.73-4.226-1.883.18-.747.795-1.397 1.664-1.833a4.257 4.257 0 002.561.86c.96 0 1.847-.323 2.562-.86zm5.059-1.141c.435.218.743.542.833.916a2.853 2.853 0 01-2.114.94c-.138 0-.273-.013-.406-.031a4.61 4.61 0 00-1.205-1.62c.1-.075.209-.145.33-.205.358.267.8.429 1.28.429.482 0 .924-.162 1.282-.43zm-12.679 0c.121.06.23.13.33.206a4.622 4.622 0 00-1.205 1.619A3.018 3.018 0 019.66 21c-.837 0-1.59-.365-2.114-.941.09-.374.398-.698.833-.916.358.267.8.429 1.281.429.48 0 .924-.162 1.281-.43zM16.001 14a2.857 2.857 0 110 5.714 2.857 2.857 0 010-5.714zm6.338 2a1.43 1.43 0 11-.001 2.858 1.43 1.43 0 010-2.858zm-12.68 0a1.43 1.43 0 010 2.858 1.428 1.428 0 010-2.858zm6.922-10.814l7 5a1 1 0 11-1.163 1.627L16 7.229l-6.419 4.584a1.001 1.001 0 01-1.163-1.627l7-5a1.002 1.002 0 011.163 0z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi081;
